import apiCallTemplate from './config'
import credentials from '../assets/credentials'

const {BASE_URL}=credentials
const usersURL = `${BASE_URL}/users`;

//Get all users
export const allUsers=async (query)=>apiCallTemplate("get", `${usersURL}?${query}`)

//User Profile
export const myProfile=async (query)=>apiCallTemplate("get", `${usersURL}/profile/me${query || ""}`)

//Update User Profile
export const UpdateProfile=async (id, data)=>apiCallTemplate("put", `${usersURL}/edit-profile/${id}`, data)

//Toogle  User Suspend Status
export const userSuspensionToggler=async (id)=>apiCallTemplate("get", `${usersURL}/suspend-unsuspend/${id}`)

//Delete User
export const deleteUser=async (id)=>apiCallTemplate("delete", `${usersURL}/${id}`)

//Users Statistics
export const userStatistics=async ()=>apiCallTemplate("get", `${usersURL}/get/statistics`)

//Contacts Us
export const contactUs=async (data)=>apiCallTemplate("post", `${usersURL}/contact-us`, data)